// extracted by mini-css-extract-plugin
module.exports = {"grid":"internal-grid_grid__ZlGlh"};